import React, { useCallback, useState } from "react";
import ServiceLocator from "../../../../../domain/service-locator";
import { QuestionnaireFormModal } from "./questionnaire-form-modal";
import { QuestionnaireCompleteSubmitModal } from "./questionnaire-complete-submit-modal";
import { AcoustiGuideQuestionnaireData } from "./acousti-guide-questionnaire-data";

export const QuestionnaireCard = () => {
  const activityLogModule = ServiceLocator.ActivityLogModule;
  const questionnaireRepository = ServiceLocator.QuestionnaireRepository;

  const [openCompleteModal, setOpenCompleteModal] = useState(false);
  const [openQuestionnaireModal, setOpenQuestionnaireModal] = useState(false);

  const handleSubmit = useCallback(
    (data: AcoustiGuideQuestionnaireData) => {
      activityLogModule.setUserProperty({
        age: data.age,
      });
      // GA4はイベントパラメータの配列をネイティブサポートしていないため、
      // 複数選択（pre_usage_troubles）は選択肢ごとのboolean に展開して送信する。
      // DB保存（saveQuestionnaireData）側は従来通り配列のまま保持する。
      const { pre_usage_troubles, ...rest } = data;
      activityLogModule.sendQuestionnaireEvent({
        ...rest,
        pre_usage_trouble_none: pre_usage_troubles.includes("特になかった"),
        pre_usage_trouble_usage: pre_usage_troubles.includes(
          "利用方法がわかりづらかった"
        ),
        pre_usage_trouble_price: pre_usage_troubles.includes(
          "お金がかかるかと思った"
        ),
        pre_usage_trouble_reservation: pre_usage_troubles.includes(
          "事前予約が必要かと思った"
        ),
        pre_usage_trouble_other: pre_usage_troubles.includes("その他"),
      });
      questionnaireRepository.saveQuestionnaireData(data);
      setOpenQuestionnaireModal(false);
      setOpenCompleteModal(true);
    },
    [activityLogModule, questionnaireRepository]
  );

  return (
    <>
      <div
        className={
          "relative w-full py-8 overflow-hidden text-white text-3xl flex items-center justify-between pr-4 pl-10 font-bold transition-all duration-300 rounded-3xl bg-[#9E9E9E] cursor-pointer"
        }
        onClick={() => {
          setOpenQuestionnaireModal(true);
        }}
      >
        アンケートのご協力
      </div>
      <QuestionnaireFormModal
        open={openQuestionnaireModal}
        onClose={() => setOpenQuestionnaireModal(false)}
        onSubmit={handleSubmit}
      />
      <QuestionnaireCompleteSubmitModal
        open={openCompleteModal}
        onClose={() => setOpenCompleteModal(false)}
      />
    </>
  );
};
